module.exports = __webpack_public_path__ + "assets/logo-powerschool-clever-ric1-classlink.png?68f669f1fc7f507fac37954a2700b562"